import React, {
  Fragment,
  useCallback,
  useEffect,
  useState,
  useRef,
} from "react";

const ClickOut = ({ children, onClickOut }) => {
  const wrapperRef = useRef(null);
  const handleClickOut = useCallback(
    (event) => {
      if (!wrapperRef.current || !wrapperRef.current.contains(event.target)) {
        onClickOut(event);
      }
    },
    [onClickOut]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOut);
    document.addEventListener("pointerdown", handleClickOut);
    return () => {
      document.removeEventListener("pointerdown", handleClickOut);
      document.removeEventListener("mousedown", handleClickOut);
    }
  }, []);

  return <div ref={wrapperRef}>{children}</div>;
};

const MarkerInfo = (props) => {
  const { onClose, item } = props;
  const featuredUrl = item.featured_image?.image_url || '';

  return (
    <div
      className="infoBox"
      style={{
        width: "270px",
        transform: "translateZ(0px)",
        position: "absolute",
        visibility: "visible",
        left: "-135.775px",
        bottom: "49.5687px",
        cursor: "default",
        zIndex: 99
      }}
    >
      <div className="map-box">
        <div>
          <div className="infoBox-close" onClick={onClose}>
            <i className="fa fa-times"></i>
          </div>
          <a
            target="_blank"
            href={`/listing/${item.slug}`}
            className="listing-img-container"
          >
            <img
              src={featuredUrl}
              alt={item.name}
            />
          </a>
          <div className="listing-content">
            <div className="listing-title">
              <div className="utf_listing_item_content">
                <h3>{item.name}</h3>
                <span>{item.full_address}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Gmarker = (props) => {
  const { item, hoveringItem } = props;
  const [isShowing, setIsShowing] = useState(false);

  return (
    <Fragment>
      <div
        className={`map-marker-container`}
        data-marker_id={item.id}
        onClick={(e) => setIsShowing(!isShowing)}
      >
        <div
          className={`marker-container ${hoveringItem && hoveringItem.id === item.id ? 'hovering' : ''}`}
        >
          <div className="marker-card">
            <div className="front face">
              <img src={item.marker_url} />
            </div>
            <div className="back face">
              <img src={item.selected_marker_url} />
            </div>
            <div className="marker-arrow"></div>
          </div>
        </div>
      </div>
      <ClickOut onClickOut={(e) => setIsShowing(false)}>
        {isShowing && (
          <MarkerInfo item={item} onClose={(e) => setIsShowing(false)} />
        )}
      </ClickOut>
    </Fragment>
  );
};

export default Gmarker;
